var React = require('react');
var moment = require('moment');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step5;
var { $simpleSelect, $input, $datePicker } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var apiDataConstants = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/apiDataConstants.js');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');

class Residency extends React.Component {
    constructor(props) {
        super(props);

        this.getResidencyFieldsMarkup = this.getResidencyFieldsMarkup.bind(this);
        this.getStateDropdownMarkup = this.getStateDropdownMarkup.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleOtherInstitutionChange = this.handleOtherInstitutionChange.bind(this);
        this.getInstitutionDropdownMarkup = this.getInstitutionDropdownMarkup.bind(this);
    }

    componentDidMount() {
        if (memberTypeChecker.defaultProgramTypeToResidency(this.props.appState.appType)) {
            this.props.updateStepState('residencyProgramType', 'Residency');
        }
    }

    getInstitutionDropdownMarkup() {
        if (this.props.appState.apiData.institutions && this.props.appState.apiData.institutions.length) {
            const otherInstMarkup = this.props.institutionHasOther(this.props.stepState.residencyInstitution)
                ? <div className={"field-wrap"}>
                      <label>{labels.step5.otherInstitution}</label>
                      <$input name="residencyCustomInstitution" onChange={this.handleOtherInstitutionChange} />
                </div> : null;

            return <div className={"field-wrap"}>
                <label>{labels.step5.institution}</label>
                <$simpleSelect
                    name="residencyInstitution"
                    titlefieldname="InstitutionName"
                    value={this.props.stepState.residencyInstitution}
                    programtypecode={apiDataConstants.programTypeCodes.residency}
                    selectdatafunction={selectableDataFunctions.getInstitutionSelectableOptions}
                    userdefinedstate={this.props.stepState.residencyState}
                    userdefinedcountry={this.props.stepState.residencyCountry}
                    onChange={this.handleInputChange}
                    validations={this.props.stateFieldIsRequired(this.props.stepState.residencyCountry) ? [validationFunctions.required] : []} />

                {otherInstMarkup}
            </div>;
        }
    }

    getStateDropdownMarkup() {
        if (this.props.stepState.residencyCountry) {
            return <div className={"field-wrap"} key={this.props.stepState.residencyCountry + "1"}>
                <label key={this.props.stepState.residencyCountry + "2"}>{labels.step5.state}</label>
                <$simpleSelect
                    key={this.props.stepState.residencyCountry + "4"}
                    name="residencyState"
                    value={this.props.stepState.residencyState}
                    country={this.props.stepState.residencyCountry}
                    selectdatafunction={selectableDataFunctions.getApiStatesFromAllCountries}
                    onChange={this.handleStateChange}
                    validations={this.props.stateFieldIsRequired(this.props.stepState.residencyCountry) ? [validationFunctions.required] : []} />
            </div>;
        }
    }

    getResidencyFieldsMarkup() {
        return <div>

            <div className={"field-wrap"}>
                <label>{labels.step5.country}</label>
                <$simpleSelect
                    name="residencyCountry"
                    value={this.props.stepState.residencyCountry}
                    onChange={this.handleCountryChange}
                    selectdatafunction={selectableDataFunctions.getApiCountriesFromAllCountries}
                    validations={[validationFunctions.required]} />
            </div>

            {this.getStateDropdownMarkup()}
            {this.getInstitutionDropdownMarkup()}

            <div className={"field-wrap"}>
                <label>{labels.step5.startDate}</label>
                <$datePicker
                    value={this.props.stepState.residencyStartDate && moment.utc(this.props.stepState.residencyStartDate).isValid() ? moment.utc(this.props.stepState.residencyStartDate).format('YYYY-MM-DD') : ""}
                    onInput={this.handleInputChange}
                    name="residencyStartDate"
                    type="date"
                    date-format="yyyy-mm-dd" validations={[validationFunctions.required, validationFunctions.date]} />
            </div>

            <div className={"field-wrap"}>
                <label>{labels.step5.endDate}</label>
                <$datePicker
                    value={this.props.stepState.residencyEndDate && moment.utc(this.props.stepState.residencyEndDate).isValid() ? moment.utc(this.props.stepState.residencyEndDate).format('YYYY-MM-DD') : ""}
                    onInput={this.handleInputChange}
                    name="residencyEndDate"
                    type="date"
                    date-format="yyyy-mm-dd" comparetodate={this.props.stepState.residencyStartDate} validations={[validationFunctions.required, validationFunctions.date, validationFunctions.dateGreaterThan]} />
            </div>

        </div>;
    }

    handleCountryChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
        this.props.updateStepState('residencyState', '');
        this.props.updateStepState('residencyInstitution', '');
    }

    handleStateChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
        this.props.updateStepState('residencyInstitution', '');
    }

    handleOtherInstitutionChange(event) {
        if (event.target.value) {
            this.props.handleOtherInstitutionChange(this.props.stepState.residencyCountry, this.props.stepState.residencyState, apiDataConstants.programTypeCodes.residency, 'residencyInstitution');
        }

        this.handleInputChange(event);
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    render() {
        if (memberTypeChecker.hideResidencyFields(this.props.appState.appType)) {
            return null;
        }

        return <div className={"residency-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step5.residency}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            {this.getResidencyFieldsMarkup()}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

module.exports = Residency;